<template>
    <div :class="['container', _isMobile() ? 'mobile' : '']">
        <div class="backHeader">
            <div class="headerLeft" style="cursor: pointer;" @click="$router.back()">
                <i class="iconfont">&#xe604;</i>
            </div>
            <div class="headerMain">{{ headerTitle }}</div>
            <div class="headerRight"></div>
        </div>
        <Header v-if="headerStatus" />
        <div class="home" :style="{ 'width': _isMobile() ? '100%' : '1200px' }">
            <router-view />
        </div>
    </div>
</template>
  
<script>
import { mixinDevice } from "@/utils/mixin.js";
import Header from "../components/Header";
export default {
    name: "HomeLayout",
    mixins: [mixinDevice],
    components: {
        Header,
    },
    watch: {
        '$route'(to, from) {
            this.headerStatus = to.meta.header
            this.headerTitle = to.query.name || to.meta.title
        },
    },
    data() {
        return {
            headerStatus: true,
            headerTitle:''
        };
    },
    created() {
        this.headerStatus = this.$route.meta.header
        this.headerTitle = this.$route.query.name || this.$route.meta.title
    },
};
</script>
<style lang="less" scoped>
.backHeader{
    width: 100%;
    height: 49px;
    background: #F4F4F4;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ccc;
    .headerMain{
        font-size: 16px;
        color: #303030;
        line-height: 50px;
    }
}
.container {
    .home {
        width: 100%;
        margin: 0 auto;
        background: #fff;
        display: flex;
        align-items: self-start;
        justify-content: flex-start;
    }
}
</style>